<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-15" v-if="$root.user.tipo == 'admin'">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'visualizar'}">
                                            <a v-on:click="setTab('visualizar')">
                                                <i class="material-icons">remove_red_eye</i>
                                                Visão geral
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'editar'}">
                                            <a v-on:click="setTab('editar')">
                                                <i class="material-icons">edit</i>
                                                Editar
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12" v-show="tab == 'visualizar'">

                            <!-- {{form}} -->

                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-12 col-xl-3 col-md-3" v-if="$root.user.tipo == 'admin'">
                                        <div class="submit-field margin-bottom-0">
                                            <h5>Selecione o produto:</h5>
                                            <select class="with-border" v-model="form.catalogoCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in catalogo.itens" v-if="item.estoque == 1" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>                                      
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-3">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>    
                                    <div class="col-lg-3 col-xs-6 col-xl-1 col-md-2">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>                                                                        
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <div class="table-scroll" style="overflow-x: scroll; height: 100%;">
                                <div v-for="(item, index) in Object.keys(visualizar.itens)">
                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">store</i>
                                        <b>{{item}}</b>
                                    </h4>
                                    <table class="table table-bordered table-bordered-default table-responsive margin-bottom-25">
                                        <thead>
                                            <th style="min-width: 200px;">
                                                Cliente
                                            </th>
                                            <th style="min-width: 200px; width: 200px;">
                                                Contatos
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Frete valor
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Margem p/ 5.000 Litros
                                            </th>                
                                            <th style="min-width: 100px; width: 100px;">
                                                Margem p/ 10.000 Litros
                                            </th>                        
                                            <th style="min-width: 100px; width: 100px;">
                                                Margem p/ 15.000 Litros
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Venda 5.000 Litros
                                            </th>    
                                            <th style="min-width: 100px; width: 100px;">
                                                Venda 10.000 Litros
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Venda 15.000 Litros
                                            </th>                                                                 
                                        </thead>
                                        <tbody> 
                                           
                                            <tr v-for="item2 in visualizar.itens[item]" :key="'visualizar-' + item2.cod">
                                                <td data-label="Cliente:">
                                                    {{item2.cliente.razaoSocial ? item2.cliente.razaoSocial : item2.cliente.nome}}
                                                </td>
                                                <td data-label="Contatos:" style="">
                                                    {{item2.contatos}}                                                
                                                </td>   
                                                <td data-label="Frete valor:" style="">
                                                    R$ {{item2.freteValor}}                                                
                                                </td>   
                                                <td data-label="Margem p/ 5.000 Litros:" style="">
                                                    R$ {{item2.margem5000}}                                                
                                                </td>   
                                                <td data-label="Margem p/ 10.000 Litros:" style="">
                                                    R$ {{item2.margem10000}}                                                
                                                </td>                                                                             
                                                <td data-label="Margem p/ 15.000 Litros:" style="">
                                                    R$ {{item2.margem15000}}
                                                </td>
                                                <td data-label="Venda 5.000 Litros:" style="">
                                                    R$ {{item2.venda5000}}
                                                </td>
                                                <td data-label="Margem 10.000 Litros:" style="">
                                                    R$ {{item2.margem10000}}
                                                </td>
                                                <td data-label="Margem 15.000 Litros:" style="">
                                                    R$ {{item2.margem15000}}
                                                </td>
                                            </tr>
                                                                                 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>  

                        <div class="col-xl-12 tab-editar" v-show="tab == 'editar'">

                            <!-- {{form}} -->

                            <form method="get" style="width: 100%;" class="margin-bottom-10" v-on:submit.prevent="get">
                                <div class="dashboard-box mobile margin-top-0">

                                    <!-- Headline -->
<!--                                     <div class="headline">
                                        <h3><i class="material-icons">account_circle</i> Informações gerais</h3>
                                    </div> -->

                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">                                
                                
                                            <div class="col-lg-12 col-xs-12">
                                                <h4 style="font-weight: 400; font-size: 18px; color: #000; margin-top: 5px; line-height: 120%; margin-bottom: 10px" >
                                                    <b>1-</b> Escolha o produto, a filial e o mês/ano de vigência dos preços especiais:
                                                </h4>
                                            </div>                              
                                            <div class="col-lg-3 col-xs-12 col-xl-3 col-md-3" v-if="$root.user.tipo == 'admin'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Selecione o produto:</h5>
                                                    <select class="with-border" v-model="form.catalogoCod">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option v-for="item in catalogo.itens" v-if="item.estoque == 1" :value="item.cod">{{item.nome}}</option>
                                                    </select>                                            
                                                </div>
                                            </div>                                                   
                                            <div class="col-lg-6 col-xs-12 col-xl-4 col-md-4" v-if="$root.user.tipo == 'admin'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Selecione a filial:</h5>
                                                    <select class="with-border" v-model="form.empresaCod">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                    </select>                                            
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-3">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Mês:</h5>
                                                    <select class="with-border" v-model="form.mes">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option value="1" selected>Janeiro</option>
                                                        <option value="2" selected>Fevereiro</option>
                                                        <option value="3" selected>Março</option>
                                                        <option value="4" selected>Abril</option>
                                                        <option value="5" selected>Maio</option>
                                                        <option value="6" selected>Junho</option>
                                                        <option value="7" selected>Julho</option>
                                                        <option value="8" selected>Agosto</option>
                                                        <option value="9" selected>Setembro</option>
                                                        <option value="10" selected>Outubro</option>
                                                        <option value="11" selected>Novembro</option>
                                                        <option value="12" selected>Dezembro</option>
                                                    </select>                                            
                                                </div>
                                            </div>    
                                            <div class="col-lg-2 col-xs-6 col-xl-2 col-md-2">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Ano:</h5>
                                                    <input type="number" v-model="form.ano" class="with-border">
                                                </div>
                                            </div>  
                                            <div class="col-xl-12"></div>
<!--                                             <div class="col-xs-12 col-xl-5" v-show="form.empresaCod">
                                                <div class="row">
                                                    <div class="col-lg-12 col-xs-12">
                                                        <h4 style="font-weight: 400; font-size: 18px; color: #000; margin-top: 5px; line-height: 120%; margin-bottom: 5px" >
                                                            <b>2-</b> Os preços especiais iniciam quando? <span style="opacity: 0.3;">(opcional)</span>
                                                        </h4>
                                                    </div>  
                                                    <div class="col-lg-4 col-xs-6 col-xl-5 col-md-5">
                                                        <div class="submit-field margin-bottom-20">
                                                            <h5>Data:</h5>
                                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                                        </div>
                                                    </div>  
                                                    <div class="col-lg-3 col-xs-6 col-xl-4 col-md-5">
                                                        <div class="submit-field margin-bottom-20">
                                                            <h5>Hora:</h5>
                                                            <input type="time" data-placeholder="__:___" required="" class="with-border margin-bottom-0" v-model="form.horaInicio">
                                                        </div>
                                                    </div>                                      
                                                </div>                                      
                                            </div>   -->
                                            <div class="col-xs-12 col-xl-7" v-show="form.empresaCod">
                                                <div class="row">
                                                    <div class="col-lg-12 col-xs-12">
                                                        <h4 style="font-weight: 400; font-size: 18px; color: #000; margin-top: 5px; line-height: 120%; margin-bottom: 5px" >
                                                            <b>2-</b> Qual operação deseja realizar?
                                                        </h4>
                                                    </div>  
                                                    <div class="col-xs-12">
                                                        <div class="row" style="justify-content: space-evenly;"> 
                                                            <div class="col-lg-4 col-xs-6 col-xl-4 col-md-4">
                                                                <div class="submit-field margin-bottom-0">
                                                                    <h5>Operação:</h5>
                                                                    <select class="with-border margin-bottom-5" v-model="form.operacao">
                                                                        <option value="" selected>Manter</option>
                                                                        <option value="aumento" selected>Aumento</option>
                                                                        <option value="baixa" selected>Baixa</option>
                                                                    </select>   
                                                                </div>
                                                            </div>                                          
                                                            <div class="col-lg-3 col-xs-6 col-xl-3 col-md-3" v-if="form.operacao == 'aumento' || form.operacao == 'baixa'">
                                                                <div class="submit-field margin-top-0 margin-bottom-0">
                                                                    <h5>Percentual:</h5>
                                                                    <input type="number" placeholder="____" v-model="form.operacaoValor" class="with-border">
                                                                </div>
                                                            </div>   

                                                            <div class="col-xs-12">
                                                                <hr style="opacity: 0.6;"> 
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2 col-xl-6 col-xs-12 hidden-md hidden-xs">
                                                        <div class="submit-field" style="text-align: right;">
                                                            <!-- <div class="hidden-xl hidden-lg hidden-sm " style="margin-top: 26px"></div> -->
                                                            <button class="button gray " type="button" v-if="form.empresaCod && form.ano && form.mes" style="width: 49%" v-on:click="checkOperacao">
                                                                <i class="material-icons">refresh</i> Atualizar
                                                            </button>       
                                                            <button class="button gray " style="width: 49%" v-if="form.empresaCod && form.ano && form.mes" type="button" v-on:click="submit">
                                                                <i class="material-icons">save</i> Salvar
                                                            </button>                                                                                             
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2 col-xl-4 col-xs-12 hidden-xl hidden-lg">
                                                        <div class="submit-field">
                                                            <!-- <div class="hidden-xl hidden-lg hidden-sm " style="margin-top: 26px"></div> -->
                                                            <div class="hidden-xs hidden-md clearfix" style="margin-top: 27px;"></div>
                                                            <button class="button gray " type="button" v-if="form.empresaCod && form.ano && form.mes" style="width: 49%" v-on:click="checkOperacao">
                                                                <i class="material-icons">refresh</i>
                                                            </button>       
                                                            <button class="button gray " style="width: 49%" v-if="form.empresaCod && form.ano && form.mes" type="button" v-on:click="submit">
                                                                <i class="material-icons">save</i>
                                                            </button>                                                                                             
                                                        </div>
                                                        <div class="hidden-xl hidden-lg hidden-md" style="height: 15px"></div>
                                                    </div>
                                                </div>                                      
                                            </div>                                      
                                        </div>                                      
                                    </div>                                      

                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <div class="table-scroll scroll-to-editar" style="overflow-x: scroll; height: 100%" v-show="form.empresaCod && form.ano && form.mes">

                                <table class="table table-bordered table-bordered-default table-responsive margin-bottom-0">
                                    <thead>
<!--                                         <th style="min-width: 10px;" class="hidden-xl hidden-lg">
                                            #
                                        </th> -->
                                        <th style="min-width: 200px;">
                                            Cliente
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            Contatos
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Frete valor
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Margem p/ 5.000 Litros
                                        </th>                
                                        <th style="min-width: 100px; width: 100px;">
                                            Margem p/ 10.000 Litros
                                        </th>                        
                                        <th style="min-width: 100px; width: 100px;">
                                            Margem p/ 15.000 Litros
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Venda 5.000 Litros
                                        </th>    
                                        <th style="min-width: 100px; width: 100px;">
                                            Venda 10.000 Litros
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Venda 15.000 Litros
                                        </th>   
                                        <th style="min-width: 20px; width: 20px;" v-if="$root.user.tipo == 'admin'">
                                            
                                        </th>                                                                      
                                    </thead>
                                    <tbody v-bind:class="{'read-only': $root.user.tipo != 'admin'}"> 


                                        <tr v-show="form.itens.length == 0 && loaded">
                                            <td data-label="" colspan="4">
                                                Nenhum preço cadastrado.
                                            </td>                                                                                           
                                        </tr>
                                       
                                        <tr v-for="(item, index) in form.itens" :key="'editar-' + item.cod">
                                            <td data-label="" class="hidden-lg hidden-xl hidden-md">
                                                Item #{{index+1}}

                                                <button type="button" class="button color-red small float-right" style="margin-top: -10px !important; height: 34px; line-height: 34px; padding-top: 0px; padding-bottom: 0px;" v-on:click="del(item)">
                                                    <i class="material-icons">close</i>
                                                </button>

                                            </td>
                                            <td data-label="Cliente:">
                                                <select class="selectpicker" v-model="item.clienteCod" :disabled="item.cod">
                                                    <!-- <option value="" disabled selected hidden>Selecione aqui..</option> -->
                                                    <!-- <option v-if="item.clienteCod && item.id ? (item2.cod == item.clienteCod) : true" v-for="item2 in clientes.itens" :key="'cliente-' + item2.cod" :value="item2.cod">{{item2.razaoSocial ? item2.razaoSocial : item2.nome}}</option> -->
                                                    <option v-if="item.clienteCod && item.id ? (item2.cod == item.clienteCod) : true" v-for="item2 in clientes.itens" :key="'cliente-' + item.cod + '-' + item2.cod" :value="item2.cod">{{item2.razaoSocial ? item2.razaoSocial : item2.nome}}</option>
                                                </select>                                                   
                                            </td>
                                            <td data-label="Contatos:" style="" class="td-50-mobile td-50-mobile-l">
                                                <input type="text" v-model="item.contatos" class="with-border">
                                            </td>                                          
                                            <td data-label="Frete valor: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.freteValor" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Margem 5000 litros: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.margem5000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Margem 10000 litros: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.margem10000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Margem 15000 litros: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.margem15000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Venda 5000 litros: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.venda5000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Venda 10000 litros: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.venda10000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>
                                            <td data-label="Venda 15000: (R$)" style="" class="td-50-mobile td-50-mobile-l">
                                                <money :key="'editar-valor-' + item.cod" v-model="item.venda15000" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </td>                                                                                                                                                                                                                                                                        
                                            <td data-label="" class="" v-if="$root.user.tipo == 'admin'">
                                                <button type="button" class="button color-red hidden-xs" v-on:click="del(item)">
                                                    <i class="material-icons">close</i>
                                                </button>
                                            </td>                                                                                             
                                        </tr>
                                                                             
                                    </tbody>
                                </table>

                                <a class="button small gray margin-top-10 margin-bottom-20" v-on:click="add" v-if="$root.user.tipo == 'admin'">
                                    <i class="material-icons">add</i>
                                    Adicionar linha
                                </a>


                            </div>
                        </div>                    
                        <div class="col-xl-12" v-show="tab == 'editar' && form.empresaCod && form.ano && form.mes" v-if="$root.user.tipo == 'admin'">

                            <div class="checkbox margin-top-15">
                                <input type="checkbox" id="destaque" v-model="form.notificacao" v-bind:value="1">
                                <label for="destaque"><span class="checkbox-icon"></span> Notificar a filial sobre a atualização dos preços especiais.</label>
                            </div>

                            <br>

                            <!-- <div class="hidden-xs clearfix margin-top-30"></div> -->
                            <button type="button" v-on:click="submit" class="button ripple-effect big block-mobile green margin-top-10" v-bind:class="{'disabled': loading.submit }">
                                <i class="material-icons">save</i>
                                Salvar alterações
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'PrecosEspeciaisGranel',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
            // return value.toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "visualizar",
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "dataOriginal":         {
                "itens":            []
            },            
            "loading": {
                "submit":           false
            },
            "clientes": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },
            "catalogo": {
                "itens":            []
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "empresaCod":       "",
                "catalogoCod":      "",
                "operacao":         "",
                "operacaoValor":    "",
                "produtos":         [],
                "valor":            "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),
                "notificacao":      0,
                "itens":            []
            },
        }
    },
    watch: {
        "form.empresaCod": function(val) {
            console.log("watch > form.empresaCod", val);
            var self = this;
            if (self.tab == "editar") {
                self.getEditar(true);
            }
        },
        "form.ano": function(val) {
            console.log("watch > form.ano", val);
            var self = this;
            if (self.tab == "editar") {
                self.getEditar(true);
            } else {
                self.getVisualizar(true);
            }
        },
        "form.mes": function(val) {
            console.log("watch > form.mes", val);
            var self = this;
            if (self.tab == "editar") {
                self.getEditar(true);
            } else {
                self.getVisualizar(true);
            }
        },
        // "form.operacao": function(val) {
        //     console.log("watch > form.operacao", val);
        //     var self = this;
        //     if (self.tab == "editar") {
        //         self.checkOperacao();
        //         // self.getEditar(true);
        //     }
        // },
        // "form.operacaoValor": function(val) {
        //     console.log("watch > form.operacaoValor", val);
        //     var self = this;
        //     if (self.tab == "editar") {
        //         self.checkOperacao();
        //         // self.getEditar(true);
        //     }
        // }                                
    },
    methods: {
        checkOperacao: function() {
            var self        = this;
            console.log("checkOperacao()", self.form.produtos);

        },
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            if (tab == "visualizar") {
                self.getVisualizar(true);
            }
        },  
        editar: function(empresaCod) {
            var self        = this;
            console.log("editar()", empresaCod);
            self.form.empresaCod = empresaCod;
            self.setTab("editar");

        },                
        add: function() {
            console.log("add")
            var self            = this;
            self.form.itens.push({
                "empresaCod":   self.form.empresaCod,
                "ano":          self.form.ano,
                "mes":          self.form.mes,
                "clienteCod":   "",
                "contatos": "Contato de exemplo",
                "freteValor": "0,45",
                "margem5000": "0,35",
                "margem10000": "0,30",
                "margem15000": "0,25",
                "venda5000": "2,94",
                "venda10000": "2,89",
                "venda15000": "2,84",
                "catalogoCod":  self.form.catalogoCod
            });

            setTimeout(function() {

                $('.selectpicker').selectpicker({
                    virtualScroll: true,
                    liveSearch: true,
                    noneResultsText: "Nenhum resultado encontrado.",
                    liveSearchPlaceholder: "Pesquise aqui..",
                    size: 10
                });

            }, 500);

        },
        del: function(item) {
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                var index = self.form.itens.indexOf(item);
                self.form.itens.splice(index, 1);
            });
        },        
        submit: function() {
            var self            = this;
            console.log("submit()", self.form);
            
            self.loading.submit = true;
            loading.show();
                
            axios.put("api/precos-especiais-granel.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },        
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin") {
                    resolve(true);
                    return false;
                }

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },   
        getClientes: function() {
            var self        = this;
            console.log("getClientes()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin") {
                    resolve(true);
                    return false;
                }

                var form = {
                    "db":               "clientes",
                    "params": {
                        "all":          true,
                        "precosEspeciais": true,
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("getClientes() response", response);
                    self.clientes       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getClientes() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },      
        getCatalogo: function() {
            var self        = this;
            console.log("getCatalogo()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin") {
                    resolve(true);
                    return false;
                }

                var form = {
                    "db":               "catalogo",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("getCatalogo() response", response);
                    self.catalogo       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCatalogo() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },       
        getVisualizar: function(load) {
            var self        = this;
            console.log("getVisualizar()", self.form);
            self.visualizar.itens   = [];
            self.loaded             = false;
            // if (load) loading.show();
            return new Promise(function(resolve, reject) {
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "ano":          self.form.ano,
                    "mes":          self.form.mes,
                };

                axios({
                    "method":       "GET",
                    "url":          "api/precos-especiais-granel.php",
                    "db":           "precosEspeciais",
                    "params":       form
                }).then(response => {
                    
                    console.log("getVisualizar() response", response);   

                    self.visualizar.itens   = response.data.result.itens;
                    self.loaded             = true;
                    if (load) loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();

                    // self.$root.salvarDB("precosEspeciais", form.params, response.data.result);
  
                })
                .catch(error => {
                    console.log("getVisualizar() error", error);                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                }); 
            });   
        },                
        getEditar: function(load, scroll) {
            var self        = this;
            console.log("getEditar()", self.form);
            self.form.itens = [];
            self.form.dataInicio    = "";
            self.form.horaInicio    = "";
            self.form.operacao      = "";
            self.form.operacaoValor = "";
            self.loaded     = false;
            if (load) loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin") {
                    resolve(true);
                    return false;
                }

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "empresaCod":   self.form.empresaCod,
                        "ano":          self.form.ano,
                        "mes":          self.form.mes,
                    }
                };

                axios.get("api/precos-especiais-granel.php", form)
                .then(response => {
                    
                    console.log("getEditar() response", response);

                    if (self.$root.user.tipo == "admin") {
                        self.dataOriginal   = JSON.parse(JSON.stringify(response.data.result));
                        console.log("Setou dataOriginal >>", self.dataOriginal)              
                    }

                    if (response.data.result.itens) {
                        if (response.data.result.itens[0]) {
                            if (response.data.result.itens[0].dataInicio != "0000-00-00") {
                                console.log("Possui dataInicio", response.data.result.itens[0].dataInicio)
                                self.form.dataInicio = response.data.result.itens[0].dataInicio;
                            }
                            if (response.data.result.itens[0].horaInicio != "00:00:00") {
                                console.log("Possui horaInicio", response.data.result.itens[0].horaInicio)
                                self.form.horaInicio = response.data.result.itens[0].horaInicio;
                            }                            
                        }
                    }

                    if (response.data.result.itens.length == 0 && self.$root.user.tipo == "admin") {
                        response.data.result.itens.push({
                            "empresaCod":   self.form.empresaCod,
                            "ano":          self.form.ano,
                            "mes":          self.form.mes,
                            "clienteCod":   "",
                            "valor":        "",
                            "catalogoCod":  ""
                        });
                    }

                    if (response.data.result.itens.length > 0) {
                        var produtos        = [];
                        var produtosKey     = {};
                        response.data.result.itens.forEach(function(item) {
                            console.log("item>", item);
                            if (!produtosKey[item.catalogoCod]) {
                                console.log("add produto", item);
                                item.catalogo.operacao = "";
                                item.catalogo.operacaoValor = "";
                                produtos.push(item.catalogo);
                                produtosKey[item.catalogoCod] = true;
                            }
                        });
                        self.form.produtos  = produtos;
                        self.$forceUpdate();
                        console.log("Produtos:", produtos);
                    }

                    self.form.itens         = response.data.result.itens; 
                    self.loaded             = true;
                    resolve(response.data.result);
                    // self.$root.scrollTop();
                    $(".dashboard-content-inner")[0].scrollTo({
                        top:            0
                    });     
                    setTimeout(function() {

                        if (self.$root.mobile.isMobile) {
                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            $(".scroll-to-editar").offset().top - 70
                            });     
                        }
                        if (load) loading.hide();

                        $('.selectpicker').selectpicker({
                            virtualScroll: true,
                            liveSearch: true,
                            noneResultsText: "Nenhum resultado encontrado.",
                            liveSearchPlaceholder: "Pesquise aqui..",
                            size: 10
                        });

                    }, 500);


                })
                .catch(error => {
                    console.log("getEditar() error", error);                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        init: function() {
            console.log("init()")
            var self = this;
            Promise.all([
                self.getVisualizar(),
                self.getEmpresas(),
                self.getClientes(),
                self.getCatalogo()
            ]).then(function() {
            
                self.$forceUpdate();
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });             
        }
    },
    created: function() {
        var self = this;

        if (self.$root.user.tipo == "prestador") {
            self.form.empresaCod    = self.$root.user.empresaCod;
        } 

        loading.show();

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();        
            });
        } else {
            self.init();
        }

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }

    input[type="date"], input[type="time"] {
        text-indent: 5px !important;
    }

    input, select {
        line-height: 40px;
        height: 40px;
        padding-left: 0px;
        text-indent: 10px;
        color: #666 !important;
        border-color: #ddd !important;
    }

    .submit-field h5 {
        font-size: 14px;
        margin-bottom: 0px;
    }

    .tab-editar .button.gray {
        height: 40px;
        line-height: 40px;
        padding-top: 0px;
        padding-bottom: 0px;        
    }

    td .button.color-red.hidden-xs {
        height: 40px;
        line-height: 40px;
        padding-top: 0px;
        padding-bottom: 0px;        
    }

    .dashboard-box .with-padding {
        padding: 15px 15px 0px 15px !important;
    }

    @media only screen and (max-width: 1099px) {
        .td-50-mobile-r {
            border-right: none !important;
        }
        .td-50-mobile-l {
            border-left: none !important;
        }    
        .td-50-mobile {
            width: 50%;
            display: inline-block;
        }    
    }    

</style>



// WEBPACK FOOTER //
// src/components/PrecosEspeciaisGranel.vue